import { ALL_WEEK_DAYS, WeekDay } from '_/services/models/enums/week-day.enum';
import { RoleAccessesModel } from '_/services/models/role-accesses.model';
import { getDay } from 'date-fns';

export function weekDayOf(date: Date): WeekDay {
  const weekDay = getDay(date);
  return ALL_WEEK_DAYS[weekDay];
}

export function weekDaysAllowed(roleAccesses: RoleAccessesModel[]): WeekDay[] {
  return [...new Set(roleAccesses.flatMap((ra) => ra.weekDays))];
}
